import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useInputStyles = makeStyles(theme => ({
	root: {
		borderRadius: theme.shape.borderRadius,
		backgroundColor: COLORS.BACKGROUND_INPUT,
		fontSize: theme.typography.body2.fontSize,
		'&:hover': {
			backgroundColor: COLORS.BACKGROUND_INPUT_HOVER
		}
	},
	underline: {
		'&:before': {
			borderBottom: 0
		},
		'&:hover:before': {
			borderBottom: 0
		}
	},
	inputMarginDense: {
		paddingTop: props => (props.hiddenlabel ? 10 : 26),
		paddingBottom: 8
	}
}));

export const useFormHelperTextStyles = makeStyles({
	contained: {
		marginLeft: 10,
		marginRight: 10
	},
	marginDense: {
		marginTop: 2
	}
});
